import React, { useState } from "react";
import { HamburgerButton } from "./HamburgerButton";
import { MenuDrawer } from "./MenuDrawer";

export const HamburgerMenu = () => {
  const [menuVisibility, setMenuVisibility] = useState<boolean>(false);

  return (
    <>
      <HamburgerButton onClick={() => setMenuVisibility(true)} />
      <MenuDrawer isOpen={menuVisibility} onDismiss={() => setMenuVisibility(false)} />
    </>
  );
};
